import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import axios from "../../../utils/BasicAuthAPI";
import moment from "moment";
import liracrypt from "../../Liracrypt/liracrypt";

const { Text, Link } = Typography;

const EventEditModal = (props) => {
  const [visible, setVisible] = useState(false);
  const [validationError, setValidationError] = useState({
    planError: null,
    actualError: null,
  });
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [form] = Form.useForm();

  const handleChangeEvent = (e) => {
    const planFrom = form.getFieldValue("PlanSeriesFrom");
    const planTo = form.getFieldValue("PlanSeriesTo");
    const actualFrom = form.getFieldValue("ActualSeriesFrom");
    const actualTo = form.getFieldValue("ActualSeriesTo");

    let errorMsg = { planError: null, actualError: null };
    if (!checkFromAndToDateValidation(planFrom, planTo)) {
      errorMsg.planError = "`From Date` can't be greater then `To Date`";
    }
    if (!checkFromAndToDateValidation(actualFrom, actualTo)) {
      errorMsg.actualError = "`From Date` can't be greater then `To Date`";
    }
    setValidationError(errorMsg);
  };

  const getGroupLabel = (values) => {
    const GroupID = values["groupid"];
    let group = props.items.filter((item) => item.key === GroupID);
    if (group.length > 0) {
      group = group[0];
      return group.value;
    }
    return null;
  };

  const handleCancel = (e) => {
    setVisible(false);
    setValidationError({ planError: null, actualError: null });
    props.modelCloseHandler(false);
  };

  const checkFromAndToDateValidation = (fromDate, toDate) => {
    return toDate >= fromDate;
  };

  const onFinish = (values) => {
    setDisabledBtn(true);
    let error = false;
    let errorMsg = { planError: null, actualError: null };
    if (
      !checkFromAndToDateValidation(
        values["PlanSeriesFrom"],
        values["PlanSeriesTo"]
      )
    ) {
      error = true;
      errorMsg.planError = "`From Date` can't be greater then `To Date`";
    }
    if (
      !checkFromAndToDateValidation(
        values["ActualSeriesFrom"],
        values["ActualSeriesTo"]
      )
    ) {
      error = true;
      errorMsg.actualError = "`From Date` can't be greater then `To Date`";
    }

    if (error) {
      setValidationError(errorMsg);
      setDisabledBtn(false);
      return;
    }

    const planData = {
      seriesFrom: values["PlanSeriesFrom"].format("YYYY/MM/DD"),
      seriesTo: values["PlanSeriesTo"].format("YYYY/MM/DD"),
    };
    const actualData = {
      seriesFrom: values["ActualSeriesFrom"].format("YYYY/MM/DD"),
      seriesTo: values["ActualSeriesTo"].format("YYYY/MM/DD"),
    };

    let plan =
      props.data[0]["plact"] === "plan" ? props.data[0] : props.data[1];
    let actual =
      props.data[0]["plact"] === "actual" ? props.data[0] : props.data[1];

    if (plan && actual) {
      const postdata = [
        {
          ...plan,
          ...planData,
          subTyp: plan.subTyp ? plan.subTyp : null,
          groupLabel: getGroupLabel(values),
          groupid: values["groupid"],
          itemName: values["itemName"],
          note: values["note"],
          st: values["st"],
        },
        {
          ...actual,
          ...actualData,
          subTyp: actual.subTyp ? actual.subTyp : null,
          groupLabel: getGroupLabel(values),
          groupid: values["groupid"],
          itemName: values["itemName"],
          note: values["note"],
          st: values["st"],
        },
      ];

      liracrypt.patch("v03/calendar/event", postdata).then(({ data }) => {
        message.success("Event edit successfully !!", 4);
        setVisible(false);
        setDisabledBtn(false);
        props.modelCloseHandler(true);
      });
    } else {
      message.error("Selected invalid bar", 4);
    }
  };

  useEffect(() => {
    if (props.visible) {
      setVisible(props.visible);
    }
    if (props.data) {
      if (props.data.length == 2) {
        let plan =
          props.data[0]["plact"] === "plan" ? props.data[0] : props.data[1];
        let actual =
          props.data[0]["plact"] === "actual" ? props.data[0] : props.data[1];
        form.setFieldsValue({
          groupid: plan.groupid,
          itemName: plan.itemName,
          note: plan.note,
          st: plan.st,
          PlanSeriesFrom: plan["seriesFrom"]
            ? moment(plan["seriesFrom"], "YYYY/MM/DD")
            : null,
          PlanSeriesTo: plan["seriesTo"]
            ? moment(plan["seriesTo"], "YYYY/MM/DD")
            : null,
          ActualSeriesFrom: actual["seriesFrom"]
            ? moment(actual["seriesFrom"], "YYYY/MM/DD")
            : null,
          ActualSeriesTo: actual["seriesTo"]
            ? moment(actual["seriesTo"], "YYYY/MM/DD")
            : null,
        });
      }
    }
  }, [props]);
  return (
    <React.Fragment>
      {props.visible ? (
        <Modal
          title={"Edit Event"}
          open={visible}
          onOk={handleCancel}
          onCancel={handleCancel}
          className={"ThemeModal"}
          width={960}
        >
          <div className="ThemeForm">
            <Form
              form={form}
              name="evntForm"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              colon={false}
              onFinish={onFinish}
              size="large"
            >
              <Row gutter={24} justify="space-around" align="middle">
                <Col span={12}>
                  <Form.Item
                    name="groupid"
                    label="Item"
                    rules={[
                      {
                        required: true,
                        message: "Please select a group",
                      },
                    ]}
                  >
                    <Select placeholder="Please select a group">
                      {props.items.map((item) => (
                        <Select.Option key={item.key} value={item.key}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="itemName"
                    label="Desc"
                    placeholder="Enter event description..."
                    rules={[
                      {
                        required: true,
                        message: "Please input event description",
                      },
                      {
                        max: 200,
                        message: "Accept max 200 char",
                      },
                    ]}
                  >
                    <Input placeholder="Enter event description..." />
                  </Form.Item>
                  <Form.Item
                    name="note"
                    label="Note"
                    placeholder="Enter event note..."
                    rules={[
                      { required: true, message: "Please input event note" },
                      {
                        max: 400,
                        message: "Accept max 400 char",
                      },
                    ]}
                  >
                    <Input placeholder="Enter event note..." />
                  </Form.Item>
                  <Form.Item
                    name="st"
                    label="Status"
                    placeholder="Select a Status"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Please select a status"
                      optionLabelProp="label"
                    >
                      <Select.Option key={"status_O"} value="O" label="Open">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#e74c3c",
                            paddingLeft: "10px",
                          }}
                        >
                          Open
                        </div>
                      </Select.Option>
                      <Select.Option key={"status_C"} value="C" label="Close">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#2ecc71",
                            paddingLeft: "10px",
                          }}
                        >
                          Close
                        </div>
                      </Select.Option>
                      <Select.Option key={"status_H"} value="H" label="Hold">
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#3498db",
                            paddingLeft: "10px",
                          }}
                        >
                          Hold
                        </div>
                      </Select.Option>
                      <Select.Option
                        key={"status_X"}
                        value="X"
                        label="Cancelled"
                      >
                        <div
                          style={{
                            borderLeft: "5px solid",
                            borderColor: "#ecf0f1",
                            paddingLeft: "10px",
                          }}
                        >
                          Cancelled
                        </div>
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <p
                    style={{
                      marginTop: "0px",
                      color: "rgba(255, 255, 255, 0.65)",
                      fontSize: "18px",
                      marginBottom: "5px",
                    }}
                  >
                    Plan Dates:
                  </p>
                  {validationError.planError ? (
                    <Text type="danger">{validationError.planError}</Text>
                  ) : null}
                  <Form.Item
                    name="PlanSeriesFrom"
                    label="From Date"
                    placeholder="Select Plan From Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      className="gx-mb-3 gx-w-100 custom-blue-bg-color"
                      placeholder="Select Plan from Date"
                      onChange={handleChangeEvent}
                    />
                  </Form.Item>
                  <Form.Item
                    name="PlanSeriesTo"
                    label="To Date"
                    placeholder="Select Plan to Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      className="gx-mb-3 gx-w-100 custom-blue-bg-color"
                      placeholder="Select Plan to Date"
                      onChange={handleChangeEvent}
                    />
                  </Form.Item>
                  <p
                    style={{
                      marginTop: "20px",
                      color: "rgba(255, 255, 255, 0.65)",
                      fontSize: "18px",
                      marginBottom: "5px",
                    }}
                  >
                    Actual Dates:
                  </p>
                  {validationError.actualError ? (
                    <Text type="danger">{validationError.actualError}</Text>
                  ) : null}
                  <Form.Item
                    name="ActualSeriesFrom"
                    label="Actual From Date"
                    placeholder="Select Actual From Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      className="gx-mb-3 gx-w-100 custom-pink-bg-color"
                      placeholder="Select Actual Date"
                      onChange={handleChangeEvent}
                    />
                  </Form.Item>
                  <Form.Item
                    name="ActualSeriesTo"
                    label="Actual To Date"
                    placeholder="Select Actual to Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      className="gx-mb-3 gx-w-100 custom-pink-bg-color"
                      placeholder="Select Actual Date"
                      onChange={handleChangeEvent}
                    />
                  </Form.Item>
                </Col>

                <div className="formBtnGroupDiv">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button gx-mt-1 bigBtn"
                    disabled={disabledBtn}
                  >
                    {"Submit"}
                  </Button>
                </div>
              </Row>
            </Form>
          </div>
        </Modal>
      ) : null}
    </React.Fragment>
  );
};

export default EventEditModal;
